import React, {useState, useEffect, useRef} from 'react';
//container
import View from './handicap-card-view';
import Edit from './handicap-card-edit';
//utils
import {UserService} from '../../../utils/data-transfer';
import AuthorisationService from '../../../utils/authorisation/authorisationService';

const HandicapCardContainer = (props) => {
  const userService = useRef(new UserService());
  const [isEdit, setIsEdit] = useState(false);
  const [state, setState] = useState({
    isLoading: true,
    details: null
  });

  useEffect(() => {
    const bootstrapComponent = async () => {
      if (state.details)
        return;

      let user = await AuthorisationService.getUser();
      const details = await userService.current.getUserHandicap(user.profile.sub);

      setState((prevState => ({...prevState, isLoading: false, details})));
    };

    bootstrapComponent();
  }, [state.details]);

  const submitScores = async (stateModel) => {
    setState((prevState => ({...prevState, isLoading: true})));
    setIsEdit(false);

    const model = {...stateModel};

    if (model.isOfficialHandicap) {
      model.handicap = null;
    } else {
      model.handicapIndex = null;
      model.handicapNumber = null;
    }

    await userService.current.setUserHandicap(model);

    setState((prevState => ({...prevState, details: null})));
  };

  return (
    isEdit ?
      <Edit
        setIsEdit={setIsEdit}
        {...state}
        submitScores={submitScores}/> :
      <View
        setIsEdit={setIsEdit}
        {...state}/>
  );
};

export default HandicapCardContainer;
